module.exports = __webpack_public_path__ + "static/media/et.97067753.png";